import React from "react";
import TextAreaWrapper from "../utilities/TextAreaWrapper";
import ApiService from "../services/DataAccess/ApiService";
import Conditional from "../utilities/Conditional";
import { CountryDropdown } from "../utilities/CountrySelect/Dropdowns";
import * as $ from "jquery";

import {
  Col,
  Form,
  Button,
  FormGroup,
  InputGroup,
  FormControl,
  ButtonToolbar,
  ControlLabel,
} from "react-bootstrap";

import { Icon, AxoLocal } from "../utilities/LexUtilities";

export default class ContactForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      country: "",
      email: "",
      message: "",
      fileAttachments: [],
      showSuccessMessage: false,
      showFailureMessage: false,
    };
  }

  onModelPropertyChange = (propertyName, event) => {
    var model = Object.assign({}, this.state);
    model[propertyName] = event.target.value;
    this.setState(model);
  };

  onMessageChange = (event) => {
    this.setState({ message: event.target.value });
  };

  onSendMessage = () => {
    let { firstName, lastName, message, country, email, fileAttachments } =
      this.state;

    if (!message) {
      return;
    }

    let { toEmail } = this.props;

    this.setState({ sending: true });

    let body = `Du har modtaget en besked fra ${firstName}${
      !!lastName ? ` ${lastName}` : ""
    }.
    Denne email kan IKKE besvares. 
    For at besvare beskeden, så skriv til (${
      email || "Email adresse ikke angivet"
    }).
      
    ${message}`;

    ApiService.sendContactMail({
      to: toEmail || "info@axolex.com",
      subject: `Kontakt fra (${
        email || "Email adresse ikke angivet"
      }) - ${firstName} ${lastName} - ${country} `,
      body,
      fileAttachments: fileAttachments,
    })
      .then((response) => {
        this.setState({ sending: false });
        if (response.ok) {
          // this.setState({
          //   firstName: '',
          //   lastName: '',
          //   country: '',
          //   email: '',
          //   message: '',
          //   fileAttachments: [],
          //   showSuccessMessage: true
          // });
          this.setState({
            showSuccessMessage: true,
            sending: false,
          });
          // setTimeout(() => {
          //   this.setState({ showSuccessMessage: false });
          // }, 5000);
        } else {
          return Promise.reject("Email could not be sent.");
        }
      })
      .catch((reason) => {
        console.log(reason);
        this.setState({
          sending: false,
          showFailureMessage: true,
        });
        setTimeout(() => {
          this.setState({ showFailureMessage: false });
        }, 10000);
      });
  };

  onReset = () => {
    this.setState({
      firstName: "",
      lastName: "",
      country: "",
      email: "",
      message: "",
      fileAttachments: [],
      sending: false,
    });
  };

  validateEmail = (email) => {
    // eslint-disable-next-line
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  getEmailValidationState = (email) => {
    if (email.length === 0) {
      return null;
    }
    return this.validateEmail(email) ? "success" : "error";
  };

  selectCountry = (val) => {
    var model = Object.assign({}, this.state);
    model.country = val;
    this.setState(model);
  };

  renderFileButtonContent = () => {
    if (this.state.showFileMaxSizeWarning) {
      return (
        <div className="axored">
          <AxoLocal
            entity="ContactFormShowMaxSizeWarning"
            defaultValue={"Max 50 mb"}
          />
        </div>
      );
    }
    return (
      <span>
        <Icon glyph="icon-fontello-upload-4" />
        &nbsp; &nbsp;
        <AxoLocal
          entity="ClientDocumentTableUploadFiles"
          defaultValue={"Upload filer"}
        />
      </span>
    );
  };

  getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      console.log(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }

  saveBase64File = (file) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      var base64string = reader.result.substring(
        reader.result.indexOf("base64") + 7
      );
      this.setState((prevState) => ({
        fileAttachments: [
          ...prevState.fileAttachments,
          {
            name: file.name,
            size: file.size,
            content: base64string,
          },
        ],
      }));
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };

  onUploadFiles = () => {
    var component = this;
    $("#documentUpload").trigger("click");
    $("#documentUpload").on("change", function () {
      if (this.files.length === 0) {
        return;
      }
      try {
        var file = this.files[0];
        if (file.size / Math.pow(1024, 2) > 5) {
          component.setState({ showFileMaxSizeWarning: true });
          setTimeout(() => {
            component.setState({ showFileMaxSizeWarning: false });
          }, 3000);
          return;
        }
        component.saveBase64File(file);
      } finally {
        $("#documentUpload").off("change");
        this.value = ""; //onChange handler should be triggered when uploading the same file twice.
      }
    });
  };

  onRemoveFile = (fileName) => {
    var newFiles = this.state.fileAttachments.filter(
      (f) => f.name !== fileName
    );
    this.setState({ fileAttachments: newFiles });
  };

  renderFileNodes = () => {
    return this.state.fileAttachments.map((file) => {
      return (
        <h5 key={file.name}>
          &nbsp;&nbsp;{file.name} ({(file.size / 1024).toFixed(2)} kb)
          &nbsp;&nbsp;
          <Icon
            role="button"
            onClick={this.onRemoveFile.bind(this, file.name)}
            glyph="icon-fontello-scissors axored"
          />
        </h5>
      );
    });
  };

  MessageView = (props) => {
    return (
      <div className="text-center axoblue largeText topPadding standardMaxWidth">
        <AxoLocal
          entity="ContactFormSuccessMessage"
          defaultValue={"Tak for din henvendelse. Beskeden blev sendt"}
        />
      </div>
    );
  };

  //Props
  //firstNameLabel
  //lastNameLabel
  //countryLabel
  //emailLabel
  //messageLabel
  //sendLabel
  render() {
    let { externalStyle } = this.props;

    let state = this.state;
    let { sending, showSuccessMessage, showFailureMessage } = state;

    let { hideCountry } = this.props;

    return (
      <Col
        xs={12}
        className="nopadding topPadding bottomPadding"
        style={externalStyle}
      >
        <Form>
          <FormGroup controlId="firstName">
            <ControlLabel
              style={{
                textAlign: "left",
                fontSize: "16px",
                fontWeight: "normal",
              }}
            >
              {this.props.firstNameLabel || (
                <AxoLocal
                  entity="placeholderfirstName"
                  defaultValue={"Fornavn"}
                />
              )}
            </ControlLabel>
            <InputGroup bsSize="large">
              <InputGroup.Addon>
                <Icon glyph="icon-fontello-user-outline" />
              </InputGroup.Addon>
              <FormControl
                type="text"
                className="borderFormControlfocus"
                value={state.firstName}
                onChange={this.onModelPropertyChange.bind(this, "firstName")}
              />
            </InputGroup>
          </FormGroup>
          <FormGroup controlId="lastName">
            <ControlLabel
              style={{
                textAlign: "left",
                fontSize: "16px",
                fontWeight: "normal",
              }}
            >
              {this.props.lastNameLabel || (
                <AxoLocal
                  entity="placeholderlastName"
                  defaultValue={"Efternavn"}
                />
              )}
            </ControlLabel>
            <InputGroup bsSize="large">
              <InputGroup.Addon>
                <Icon glyph="icon-fontello-user-7" />
              </InputGroup.Addon>
              <FormControl
                type="text"
                className="borderFormControlfocus"
                value={state.lastName}
                onChange={this.onModelPropertyChange.bind(this, "lastName")}
              />
            </InputGroup>
          </FormGroup>
          {!hideCountry ? (
            <FormGroup controlId="country" className="onTop">
              <ControlLabel
                style={{
                  textAlign: "left",
                  fontSize: "16px",
                  fontWeight: "normal",
                }}
              >
                {this.props.countryLabel || (
                  <AxoLocal entity="placeholdercountry" defaultValue={"Land"} />
                )}
              </ControlLabel>
              <InputGroup bsSize="large">
                <InputGroup.Addon>
                  <Icon glyph="icon-fontello-globe-6" />
                </InputGroup.Addon>
                <CountryDropdown
                  value={state.country}
                  customSelect
                  valueType="short"
                  large
                  onChange={(val) => this.selectCountry(val)}
                />
              </InputGroup>
            </FormGroup>
          ) : null}
          <FormGroup
            validationState={this.getEmailValidationState(state.email)}
            controlId="Email"
          >
            <ControlLabel
              style={{
                textAlign: "left",
                fontSize: "16px",
                fontWeight: "normal",
              }}
            >
              {this.props.emailLabel || (
                <AxoLocal
                  entity="socialSidebarContainerEmail"
                  defaultValue={"Email"}
                />
              )}
            </ControlLabel>
            <InputGroup bsSize="large">
              <InputGroup.Addon>
                <Icon glyph="icon-fontello-mail" />
              </InputGroup.Addon>
              <FormControl
                type="text"
                className="borderFormControlfocus"
                value={state.email}
                onChange={this.onModelPropertyChange.bind(this, "email")}
              />
            </InputGroup>
            <br />
          </FormGroup>
          {this.props.attachFiles ? (
            <div className="flexbox-responsive">
              <Button
                disabled={this.state.sending}
                className="Lex-button-2"
                onClick={this.onUploadFiles}
                style={{
                  borderRadius: "0px",
                  marginLeft: "0px",
                  marginRight: "0px",
                  width: "250px",
                  fontSize: "17px",
                  fontWeight: "normal",
                  height: "55px",
                }}
              >
                {this.renderFileButtonContent()}
              </Button>
              {this.renderFileNodes()}
              <input
                name="document"
                type="file"
                multiple
                id="documentUpload"
                style={{ display: "none" }}
              />
            </div>
          ) : null}
          <Conditional inline show={this.props.attachFiles}>
            <br />
          </Conditional>
          <ControlLabel
            style={{
              textAlign: "left",
              fontSize: "16px",
              fontWeight: "normal",
            }}
          >
            {this.props.messageLabel || (
              <AxoLocal
                key="Besked"
                entity="ContactFormMessage"
                defaultValue={"Besked"}
              />
            )}
          </ControlLabel>
          <FormGroup controlId="message">
            <AxoLocal
              componentClass={TextAreaWrapper}
              onChange={this.onMessageChange}
              value={this.state.message}
              rows={5}
              componentAttribute="placeholder"
              entity="ContactFormMessagePlaceholder"
            />
          </FormGroup>
          {!showSuccessMessage && !showFailureMessage && (
            <div className="flexbox-center">
              <ButtonToolbar>
                <Button
                  className="Lex-button-2"
                  disabled={sending}
                  style={{
                    borderRadius: "0px",
                    marginLeft: "0px",
                    marginRight: "0px",
                    width: "250px",
                    fontSize: "17px",
                    fontWeight: "normal",
                    height: "65px",
                  }}
                  onClick={this.onSendMessage}
                >
                  {this.props.sendLabel || (
                    <AxoLocal
                      entity="IndividualPackagetext180"
                      defaultValue={"Send besked"}
                    />
                  )}
                  {sending && (
                    <span>
                      &nbsp;
                      <img
                        alt=""
                        src="/imgs/app/loading.gif"
                        className="img-circle"
                        width="20"
                        height="20"
                      />
                    </span>
                  )}
                </Button>
                <Button
                  disabled={sending}
                  className="Lex-button-2"
                  style={{
                    borderRadius: "0px",
                    marginLeft: "0px",
                    marginRight: "0px",
                    width: "250px",
                    fontSize: "17px",
                    fontWeight: "normal",
                    height: "65px",
                  }}
                  onClick={this.onReset}
                >
                  {" "}
                  <AxoLocal
                    entity="SidebarRightContainerResetCalendarEvent"
                    defaultValue={"Nulstil"}
                  />
                </Button>
              </ButtonToolbar>
            </div>
          )}
          <Conditional show={showSuccessMessage}>
            <div
              className="text-center axoblue hugeText"
              style={{ paddingTop: "15px" }}
            >
              <AxoLocal
                entity="ContactFormSuccessMessage"
                defaultValue={
                  "Tak for din henvendelse. Beskeden er blevet sendt."
                }
              />
            </div>
          </Conditional>
          <Conditional show={showFailureMessage}>
            <div className="text-center axored largeText">
              <AxoLocal
                entity="ContactFormFailureMessage"
                defaultValue={"Beskeden kunne ikke sendes. Prøv igen senere."}
              />
            </div>
          </Conditional>
        </Form>
        <br />
      </Col>
    );
  }
}
